"use client"

import type { ElementRef } from "react"
import { forwardRef } from "react"
import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"
import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

import { cn } from "../lib/utils"

const labelVariants = cva("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70")

const Label = forwardRef<
  ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<"label"> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...(props as any)} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
